"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeData = void 0;

var _apple = _interopRequireDefault(require("../../../assets/img/apple.svg"));

var _google = _interopRequireDefault(require("../../../assets/img/google.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var storeData = {
  'AppStore': {
    'link': 'https://apps.apple.com/ru/app/dom-ru-agent/id799358248?mt8',
    'img': _apple["default"],
    'alt': 'AppStore',
    'title': 'AppStore'
  },
  'GooglePlay': {
    'link': 'https://play.google.com/store/apps/details?id=com.ertelecom.agent&hl=ru',
    'img': _google["default"],
    'alt': 'GooglePlay',
    'title': 'GooglePlay'
  },
  'MovixAppStore': {
    'link': 'https://apps.apple.com/ru/app/dom-ru-tv/id825552263?mt=8&ign-mpt=uo%3D4',
    'img': _apple["default"],
    'alt': 'MovixAppStore',
    'title': 'MovixAppStore'
  },
  'MovixGooglePlay': {
    'link': 'https://play.google.com/store/apps/details?id=com.ertelecom.domrutv',
    'img': _google["default"],
    'alt': 'MovixGooglePlay',
    'title': 'MovixGooglePlay'
  },
  'SmartAppStore': {
    'link': 'https://apps.apple.com/ru/app/%D1%83%D0%BC%D0%BD%D1%8B%D0%B9-%D0%B4%D0%BE%D0%BC-ru/id1373157818',
    'img': _apple["default"],
    'alt': 'SmartAppStore',
    'title': 'SmartAppStore'
  },
  'SmartGooglePlay': {
    'link': 'https://play.google.com/store/apps/details?id=com.ertelecom.smarthome',
    'img': _google["default"],
    'alt': 'SmartGooglePlay',
    'title': 'SmartGooglePlay'
  }
};
exports.storeData = storeData;